import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Response_Processing from "../../../src/layout/Others/Response_Processing";
import { getItemToken } from "../../Utils/localStorageUtils";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../components/CommonComponents/Wrapper";
import MessageHeading from "../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../components/CommonComponents/AdminCustomInput";
import AdminCustomSelect from "../../components/CommonComponents/AdminCustomSelect";
import RightWrapper from "../../components/CommonComponents/RightWrapper";
import MessageSubHeading from "../../components/CommonComponents/MessageSubHeading";
import AdminImageUploadZone from "../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomButton from "../../components/CommonComponents/AdminCustomButton";
import { slugGenerator } from "../../components/CommonMethod/CommonMethods";
import AdminBackNavigation from "../../components/CommonComponents/AdminBackNavigation";
import FieldRenderer2 from "../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../CustomFields/saveCustomFieldsStrict";
import { useMyContext } from "../../components/Provider/CommonProvider";

function Add_Faq_category() {
  const { fetchRequest, globalImageUplaodAPI } = useMyContext()
  const { id } = useParams();
  const navigate = useNavigate();

  const baseURL = process.env.REACT_APP_Baseurl
  const headers = getItemToken('access_token')
  const labelSource = 'faq-category'

  const addApi = `${baseURL}/admin/faq-genre/store`
  const createApi = `${baseURL}/admin/faq-genre/create`
  const editApi = `${baseURL}/admin/faq-genre/edit`
  const imageApi = globalImageUplaodAPI()
  const updateApi = `${baseURL}/admin/faq-genre/update`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`

  const combinedRef = useRef({
    name: null,
    slug: null,
    parent_id: null
  });

  const [formData, setFormData] = useState({
    state: "formData",
    name: "",
    slug: "",
    parent_id: "",
  })
  const [defaultOption, setDefaultOption] = useState({
    state: "defaultOption",
    parentOption: [],
  })

  const [formDataError, setFormDataError] = useState()
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);
  const [coverImageFile, setCoverImageFile] = useState(null); const [customFieldValues, setCustomFieldValues] = useState({});

  const multiSelectLabel = (array, valueKey, labelKey) => {
    return Array.isArray(array) ? array?.map((item) => ({
      value: item[valueKey],
      label: item[labelKey]
    })) : [];
  };


  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.name) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        name: "Name  cannot be empty.",
      }));
      combinedRef.current['name'].focus()
      formIsValid = false;
    }
    if (!formData?.slug) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        slug: "Slug cannot be empty.",
      }));
      combinedRef.current['slug'].focus()
      formIsValid = false;
    }
    return formIsValid;
  }

  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const handleClearSelectFile = (value) => {
    if (value == 'image') {
      setCoverImageFile(null)
    }
    setFormDataError((prev) => ({
      ...prev,
      [value]: ""
    }))

  }

  const handleFileChange = async (event) => {
    const { files, name, value, accept } = event.target
    if (files?.length > 0) {
      const newFile = files[0];
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!allowedTypes.includes(newFile.type)) {
        toast.error('Only JPEG, PNG, and JPG images are allowed');
        return;
      }
      const reader = new FileReader();
      const readFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      };
      const fileContent = await readFile(newFile);
      if (name == 'image') {
        setCoverImageFile(newFile);
      }
    }
  };

  const handleFileUpload = async (id, name) => {
    try {
      const formDataAdd = new FormData();
      const imageFields = [];
      if (name == 'video-image') {
        formDataAdd.append('id', id)
        formDataAdd.append('modelName', 'GenreFaq');
        formDataAdd.append('image', coverImageFile)
        formDataAdd.append('imageFields[]', 'image');
        const response = await fetchRequest({ method: 'POST', url: imageApi, data: formDataAdd });
      }
      setCoverImageFile(null)

    } catch (err) {
      toast.error(err?.response?.data?.message)
    }
  }

  const handleBlurtitle = () => {
    if (!formData?.slug) {
      generateSlug(formData?.name);
    }
  };

  const generateSlug = async (name) => {
    const slug = await slugGenerator(name)
    setFormData((prev) => ({
      ...prev,
      'slug': slug,
    }));
    setFormDataError((prev) => ({
      ...prev,
      'slug': '',
    }));
  };

  const handleInputKeyDowntitle = (event) => {
    if (!formData?.slug) {
      if (event.key === "Enter" || event.key === "Tab") {
        generateSlug(formData?.name);
      }
    }
  };

  const fetchData = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${editApi}/${id}`, { headers: headers });
      const result = response?.data;
      setFormData(result?.AdminGenreFAQ)
      const defaultoptionslist = { parentOption: multiSelectLabel(result?.All_AdminGenreFAQ, 'id', 'name'), }
      setDefaultOption(defaultoptionslist);
      setShowOverlay(false)
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCreate = async () => {
    try {
      const response = await axios.get(`${createApi}`, { headers: headers });
      const result = response?.data;
      const defaultoptionslist = {
        parentOption: multiSelectLabel(result?.FAQ_Genre, 'id', 'name'),
      }
      setDefaultOption(defaultoptionslist);
    } catch (error) {
      console.error(error);
    }
  };

  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const handleAdd = async () => {
    const findApi = !id ? addApi : `${updateApi}/${id}`
    const method = 'POST';
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if (["name", "slug", "parent_id"].includes(key)) {
          formDataAdd[key] = formData[key]
        }
      }
      const response = await axios({ method: method, url: findApi, data: formDataAdd, headers: headers, });
      const result = response?.data;
      if (result?.status) {
        // save custom field values (strict)
        try {
          const entityId = id || result?.GenreFAQid || result?.id;
          await saveCustomFieldsStrict({ baseURL, headers, entityType: 'faq_category', entityId, values: customFieldValues });
        } catch (e) {
          setShowOverlay(false);
          toast.error(e?.message || 'Failed to save additional fields');
          return;
        }
        setShowOverlay(false);
        toast.success(result?.message)
        if (coverImageFile) {
          await handleFileUpload(result?.GenreFAQid, 'video-image')
          setCoverImageFile(null)
        }
        if (!id) {
          navigate("/faq-category");
        }
        else {
          setWithOutRefresh(!withOutRefresh)
        }
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
    }
  }

  const handleStore = (e) => {
    e.preventDefault()
    if (formValidation()) {
      handleAdd()
    }
  }

  useEffect(async () => {
    if (id) {
      await fetchData();
    }
    else {
      await fetchCreate()
    }
    await labelFetch();
  }, [withOutRefresh]);

  return (
    <>
      <AdminBackNavigation path="/faq-category" text="Back" />
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={!id ? labelDisplay?.[2]?.title : labelDisplay?.[9]?.title} saveText={!id ? labelDisplay?.[1]?.title : labelDisplay?.[10]?.title} saveMethod={handleStore} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={!id ? labelDisplay?.[3]?.title : formData?.name} />
            <MessageLabel text={labelDisplay?.[4]?.title} className="mandatorySimple" />
            <AdminCustomInput type="text" name="name" value={formData?.name} onChange={handleInput} placeHolder={"Name"} ref={(el) => (combinedRef.current.name = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.name} />
            <MessageLabel text={labelDisplay?.[5]?.title} className="" />
            <AdminCustomInput type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onChange={handleInput} placeHolder={"Slug"} error={formDataError?.slug} />
            <MessageLabel text={labelDisplay?.[6]?.title} />
            <AdminCustomSelect name="parent_id" value={formData?.parent_id || 0} onChange={handleInput} ref={(el) => (combinedRef.current.parent_id = el)} options={defaultOption?.parentOption?.map((item, index) => ({ name: item?.label, value: item?.value }))} defaultOptionName={"Select an Genre"} />

            <div className="card p-3 mt-3">
              {/* <MessageHeading text="Additional Fields" /> */}
              {/* Custom fields */}
              <FieldRenderer2
                pageIdentifier={id ? "faq_category.edit" : "faq_category.create"}
                entityType={"faq_category"}
                entityId={id || null}
                text="Additional Fields"
              />
              <FieldRenderer
                pageIdentifier={id ? "faq_category.edit" : "faq_category.create"}
                entityType={"faq_category"}
                entityId={id || null}
                onChange={setCustomFieldValues}
              />
            </div>
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[7]?.title} />
            <MessageLabel text={labelDisplay?.[8]?.title} />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={coverImageFile}
              uploadedImage={formData?.image}
              onDelete={handleClearSelectFile}
              ref={(el) => (combinedRef.current.image = el)}
              name="image"
              id={id}
              error={formDataError?.image}
            />
          </Wrapper>
        </RightWrapper>
        <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={!id ? labelDisplay?.[1]?.title : labelDisplay?.[10]?.title} />
      </FormContainer>
    </>
  );
}

export default Add_Faq_category;